import { useMutation, useQueryClient } from "@tanstack/react-query";

import type { CreateUserTestDto } from "~/data/user-test/create-user-test.dto";

import { createUserTest } from "~/data/user-test/user-test.service";

export function useCreateUserTestMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (dto: CreateUserTestDto) => createUserTest(dto),
    onSuccess: (data) => queryClient.setQueryData(["user_test", data.id], data),
  });
}
